import React from "react";

const ReputationSvg = ({ width = "41", height = "40", color = "white" }) => {
  return (
    <svg
      width={width + ""}
      height={height + ""}
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-v-c48ceddc=""
    >
      <path
        d="M19.7424 8.4997C19.7424 7.25293 18.7029 6.23816 17.4244 6.23816C16.1458 6.23816 15.1063 7.25231 15.1063 8.4997C15.1063 9.74708 16.1458 10.7612 17.4244 10.7612C18.7029 10.7612 19.7424 9.74708 19.7424 8.4997Z"
        stroke={color}
        stroke-miterlimit="10"
      ></path>
      <path
        d="M25.4761 11.9366C26.4463 13.7723 27.3678 15.9102 26.5598 16.1902C25.4118 16.5877 22.4308 16.2099 20.5429 15.325C20.5429 18.1416 20.5555 22.3243 20.5555 25.0499"
        stroke={color}
        stroke-miterlimit="10"
      ></path>
      <path
        d="M22.2668 11.035C22.8862 12.1083 23.8185 13.7015 23.8185 13.7015C23.8185 13.7015 21.7836 12.8147 21.1144 12.6966C19.7765 12.4535 13.9129 12.5181 13.9129 12.5181C12.7933 12.5526 12.0237 13.0492 11.9796 14.1501C11.8786 16.6572 11.9562 19.6873 11.967 22.2393C11.9701 23.008 12.6722 23.3169 13.2979 23.3593C13.9236 23.4018 14.4705 22.9009 14.6029 22.3255"
        stroke={color}
        stroke-miterlimit="10"
      ></path>
      <path
        d="M14.6036 22.3256C14.5973 22.6966 14.6086 23.0794 14.6042 23.4517C14.6042 23.4714 14.601 23.4825 14.601 23.5028C14.625 26.9293 14.5651 30.6431 14.6181 33.9723C14.6345 34.9865 15.1214 35.3539 15.9566 35.4413C16.7911 35.5286 17.5663 34.9459 17.5593 34.0351C17.5631 30.5059 17.5593 27.016 17.5606 23.4966C17.5783 23.5373 17.6098 23.4228 17.6193 23.5613C17.6956 26.1674 17.4244 32.0936 17.5587 34.0357C17.5808 34.3563 17.6136 34.7133 17.7908 34.9933C18.2135 35.6609 19.5393 35.5619 20.0818 35.0923C20.4104 34.8074 20.5113 34.3533 20.517 33.9422C20.5599 30.7305 20.5126 26.8733 20.5309 23.5065C20.5309 23.4868 20.529 23.4683 20.5284 23.4529C20.5284 23.4376 20.5252 23.4037 20.5303 23.3877"
        stroke={color}
        stroke-miterlimit="10"
      ></path>
      <path
        d="M14.6036 22.3255C14.6036 22.3009 14.6118 22.2929 14.6118 22.2677C14.6118 20.1311 14.6118 17.9889 14.6118 15.8505C14.6086 15.8505 14.6055 15.8505 14.6023 15.8505C14.6023 18.0098 14.6036 20.1631 14.6036 22.3255Z"
        stroke={color}
        stroke-miterlimit="10"
      ></path>
      <path
        d="M22.2668 11.035L25.4761 11.9366"
        stroke={color}
        stroke-miterlimit="10"
      ></path>
      <path
        d="M22.2668 11.0351L20.9567 10.6671L22.0321 8.24067L29.831 6.9939V13.1594L25.4761 11.9367"
        stroke={color}
        stroke-miterlimit="10"
      ></path>
      <path
        d="M33.8919 13.0548L31.7283 11.8136"
        stroke={color}
        stroke-miterlimit="10"
      ></path>
      <path
        d="M34.5125 7.27942L31.7283 8.23326"
        stroke={color}
        stroke-miterlimit="10"
      ></path>
      <path
        d="M31.7283 9.87939L34.2123 10.0745"
        stroke={color}
        stroke-miterlimit="10"
      ></path>
    </svg>
  );
};

export default ReputationSvg;
